export const VARIANT_NAME_QUERY_PARAM = 'variantName';
export const RULE_TAB_QUERY_PARAM = 'tab';
export const GROUPBY_SEARCH_EXPERTS = 'https://www.groupbyinc.com/contact';
